import React from "react";

const MAP = {
  Draft: "badge-draft",
  Submitted: "badge-submitted",
  Frozen: "badge-submitted",
  Approved: "badge-approved",
  Active: "badge-approved",
  Rejected: "badge-rejected",
  Open: "badge-draft",
  Partial: "badge-partial",
  Closed: "badge-closed",
  Pending: "badge-submitted",
  Verified: "badge-approved",
  Paid: "badge-paid",
  Active: "badge-approved",
  Inactive: "badge-draft",
};

export default function StatusBadge({ status, className = "" }) {
  const cls = MAP[status] || "badge-draft";
  return (
    <span
      data-testid={`status-${(status || "").toLowerCase()}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-md text-xs font-semibold tracking-wide ${cls} ${className}`}
    >
      {status || "-"}
    </span>
  );
}
